import classNames from 'classnames';
import React from 'react';

import { Checkbox } from '@eika/checkbox';
import { Icon, IconTypes } from '@eika/icon';

import type { ReceiptType } from '../../../../generated-types';
import useTranslation from '../../../../hooks/useTranslation';

import './ReceiptInput.scss';

export interface ReceiptInputProps {
    className?: string;
    onChangeReceipt: (value: ReceiptType) => void;
    receiptType?: ReceiptType;
    locked?: boolean;
}

const ReceiptInput: React.FC<ReceiptInputProps> = ({ className, onChangeReceipt, receiptType, locked = false }) => {
    const translated = useTranslation();

    const selectOption = (checked: boolean, value: string) => {
        if (!checked) {
            onChangeReceipt('NONE');
            return;
        }
        const newValue = value as ReceiptType;
        onChangeReceipt(newValue);
    };

    const onKeydownCheckbox = (e: React.KeyboardEvent<HTMLInputElement>, value: string) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            selectOption(!e.currentTarget.checked, value);
        }
    };

    return (
        <details className={classNames('receipt-selector__wrapper', className)}>
            <summary data-testid="receipt-type-selector" className="receipt-selector-summary">
                <span>{translated.receipt.needReceipt}</span>
                <Icon type={IconTypes.LITEN_PIL_NED} />
            </summary>
            <div className="receipt-selector-content__wrapper">
                <span className="receipt-selector-content__description">{translated.receipt.description}</span>
                <div data-testid="receipt-type-checkboxes" className="receipt-selector-checkbox__wrapper">
                    <Checkbox
                        onKeyDown={(e) => onKeydownCheckbox(e, 'PRINT')}
                        value="PRINT"
                        checked={receiptType === 'PRINT'}
                        label={translated.receipt.receiptTypeSimplified.PRINT}
                        onValueChange={selectOption}
                        disabled={locked}
                        data-testid="receipt-checkbox"
                    />
                    <Checkbox
                        onKeyDown={(e) => onKeydownCheckbox(e, 'STICKER')}
                        value="STICKER"
                        checked={receiptType === 'STICKER'}
                        label={translated.receipt.receiptTypeSimplified.STICKER}
                        onValueChange={selectOption}
                        disabled={locked}
                        data-testid="receipt-and-sticker-checkbox"
                    />
                </div>
            </div>
        </details>
    );
};

export default ReceiptInput;
